import {
  Component,
  ViewEncapsulation,
  ChangeDetectionStrategy,
} from "@angular/core";
import { MzBaseModal } from "ng2-materialize";
import { EventEmitter } from "@angular/core";
import { environment } from "../../../environments/environment";

@Component({
  selector: "app-confirm-leave-backlog-unsynced",
  templateUrl: "./confirm-leave-backlog-unsynced.component.html",
  styleUrls: ["./confirm-leave-backlog-unsynced.component.scss"],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmLeaveBacklogUnsyncedComponent extends MzBaseModal {
  readonly result: EventEmitter<any> = new EventEmitter();
  env: any = environment;
  isChecked: Boolean = false;
  key = "stayUnsyncedNotification";

  constructor() {
    super();
  }

  okClick() {
    if (this.isChecked) {
      localStorage.setItem(this.key, "NL@5k+I*NfJZ2pk");
    }
    this.result.emit(true);
  }

  abortClick() {
    this.result.emit(false);
  }
}



// WEBPACK FOOTER //
// /agir/src/app/components/confirm-leave-backlog-unsynced/confirm-leave-backlog-unsynced.component.ts